import {SET_SAME} from "./addressActionTypes";


export const setSameAddress = (payload: any) => {
    return {
        type: SET_SAME,
        payload,
    }
}